import { Alert, AlertProps } from '@mui/material'
import { Box, Collapse, Typography } from '@elphasecure/elpha-design-system'
import { Close } from '../../../assets/svgs'
import React from 'react'
import { styled } from '@mui/system'
import { CSSProperties } from '@mui/styled-engine'

export type IThemedBannerProps = {
  variant?: 'light' | 'dark'
  label: string
  closeButton?: boolean
  icon?: React.ReactNode
  actionLabel?: string
  action?: () => void
  sx?: CSSProperties
}

export interface IBannerProps extends AlertProps {
  colorVariant: 'light' | 'dark'
}

const StyledBanner = styled(Alert)<IBannerProps>(({ theme, colorVariant }) => ({
  backgroundColor:
    colorVariant === 'dark'
      ? theme.palette.primary[600]
      : theme.palette.primary[200],
  color:
    colorVariant === 'dark'
      ? theme.palette.common.white
      : theme.palette.primary[600],
  '& .banner-action-label': {
    color:
      colorVariant === 'dark'
        ? theme.palette.secondary.main
        : theme.palette.primary.main,
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },
  display: 'flex',
  alignItems: 'center',
}))

export default function ThemedBanner({
  variant = 'light',
  label,
  icon = false,
  closeButton = true,
  actionLabel,
  action,
  sx,
}: IThemedBannerProps) {
  const [open, setOpen] = React.useState(true)
  return (
    <Collapse in={open}>
      <StyledBanner
        sx={{ ...sx }}
        colorVariant={variant}
        icon={icon}
        action={
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              marginRight: '1.3rem',
            }}
          >
            {actionLabel && (
              <Typography
                variant="bodySmall"
                className="banner-action-label"
                sx={{
                  marginRight: closeButton ? '3rem' : 0,
                }}
                onClick={action}
              >
                {actionLabel}
              </Typography>
            )}
            {closeButton && (
              <Close
                width={'1.4rem'}
                height={'1.4rem'}
                onClick={() => setOpen(false)}
              />
            )}
          </Box>
        }
      >
        <Typography variant="bodyMedium" sx={{ fontWeight: 400 }}>
          {label}
        </Typography>
      </StyledBanner>
    </Collapse>
  )
}
